import { useInView } from '@react-spring/web';

function useTileTransitions(): any {
    const [refView, springs] = useInView(
        () => ({
            from: {
                opacity: 0,
                y: 50,
            },
            to: {
                opacity: 1,
                y: 0,
                delay: 100, // Adding delay within the animation config
            },
            config: {
                mass: 5,
                friction: 60,
                tension: 300,
            },
        }),
        {
            once: true,
        },
    );

    return [refView, springs];
}

function useTitleTransitions(): any {
    const [refView, springs] = useInView(
        () => ({
            from: {
                opacity: 0,
                y: 50,
            },
            to: {
                opacity: 1,
                y: 0,
                delay: 100,
            },
        }),
        {
            once: true,
        },
    );

    return [refView, springs];
}

function useNavigationTransitions(): any {
    const [refView, springs] = useInView(
        () => ({
            from: {
                opacity: 0,
                x: 50,
            },
            to: {
                opacity: 1,
                x: 0,
                delay: 100, // Adding delay within the animation config
            },
        }),
        {
            once: true,
        },
    );

    return [refView, springs];
}

function useSpotlightTransitions(): any {
    const [ref, springs] = useInView(
        () => ({
            from: {
                opacity: 0,
                x: 100,
            },
            to: {
                opacity: 1,
                x: 0,
                delay: 100, // Adding delay within the animation config
            },
        }),
        {
            once: true,
        },
    );
    return [ref, springs];
}

export {
    useTileTransitions,
    useNavigationTransitions,
    useSpotlightTransitions,
    useTitleTransitions,
};
